module.exports = __webpack_public_path__ + "static/img/Primary-miner.796b2dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Primary-miner.png
// module id = MEh7
// module chunks = 2